module.exports = __webpack_public_path__ + "static/media/21-4.ce5f7320.mp3";